import actions, { ErrorAction } from './actions';
import { getType, action } from "typesafe-actions";

export interface ErrorState {
    hasError: boolean;
    showError: boolean;
    ok: boolean;
    redirected: boolean;
    status: number;
    statusText: string;
    url: string;
    message: string;
}

const initialState: ErrorState = {
    hasError: false,
    showError: false,
    ok: true,
    redirected: false,
    status: null,
    statusText: null,
    url: null,
    message: null
}

export class ResponseModel {
    body: any;
    bodyUsed: any;
    headers: any;
    ok: boolean;
    redirected: boolean;
    status: number;
    statusText: string;
    type: string;
    url: string;
    message: string;
}

export const errorReducer = (state: ErrorState = initialState, action: ErrorAction): ErrorState => {
    switch (action.type) {
        case getType(actions.throwError):
            return {
                ...state,
                hasError: true,
                showError: true,
                ok: false,
                redirected: action.payload.redirected,
                status: action.payload.status,
                statusText: action.payload.statusText,
                url: action.payload.url,
                message: action.payload.message
            };
        case getType(actions.clearError):
            return { ...initialState }
        default:
            return state;
    }
};